import { jsx } from "react/jsx-runtime";
import { MilitaryInstallationHomeSearch } from "@zillow/zrs-cms";
import "react";
const BlockMilitaryInstallationHomeSearch = () => {
  return /* @__PURE__ */ jsx(MilitaryInstallationHomeSearch, {});
};
export {
  BlockMilitaryInstallationHomeSearch as default
};
